import { render, staticRenderFns } from "./StudentsListFilters.vue?vue&type=template&id=4db2aec8&"
import script from "./StudentsListFilters.vue?vue&type=script&lang=js&"
export * from "./StudentsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./StudentsListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports